import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  containerSt: {
    marginLeft: SPACES.xxxxl,
    marginRight: SPACES.xxxxl,
  },
  wrapperSt: {
    maxWidth: 1000,
    marginLeft: 'auto',
    marginRight: 'auto',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  linkSt: {
    '&&': {
      alignSelf: 'flex-start',
      marginBottom: SPACES.xxl,
    },
  },
}))
